"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLive = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var StyledSVG = _styledComponents.default.svg.withConfig({
  displayName: "DomestikaLive__StyledSVG",
  componentId: "sc-1fz1l1v-0"
})(["", " ", ""], _styledSystem.layout, (0, _styledSystem.system)({
  color: {
    properties: ['fill'],
    scale: 'colors'
  }
}));

var DomestikaLive = function DomestikaLive(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      props = (0, _objectWithoutProperties2.default)(_ref, ["width", "height", "color"]);
  return React.createElement(StyledSVG, (0, _extends2.default)({
    width: width,
    height: height,
    viewBox: "0 0 137 140",
    preserveAspectRatio: "xMidYMid meet",
    color: color
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2767 31.0434C20.2146 32.7206 21.0263 36.289 19.1588 39.3439C17.2913 42.3987 13.6803 43.4426 10.7273 41.7569C7.77373 40.0711 6.9772 36.5117 8.84466 33.4564C10.7121 30.4025 14.3232 29.3576 17.2767 31.0434ZM11.5688 35.0113C10.766 36.3249 11.1266 37.9642 12.5493 38.7762C13.9725 39.5883 15.6324 39.1025 16.4352 37.7889C17.238 36.4759 16.8774 34.8366 15.4542 34.0245C14.031 33.2125 12.3721 33.6983 11.5688 35.0113Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03659 46.1938C12.5314 47.1822 14.1902 50.1709 13.1163 53.9641L11.5905 59.3599L0 56.0816L1.52636 50.6858C2.59972 46.8926 5.57775 45.2152 9.03659 46.1938ZM4.33922 51.6355L3.85024 53.363L9.7349 55.0267L10.2233 53.2992C10.6616 51.7506 9.92679 50.3307 8.03683 49.7961C6.14687 49.2616 4.7775 50.0858 4.33922 51.6355Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1837 24.8754L26.2222 21.6362L28.1901 26.7971L26.7598 28.1761L21.6572 25.9888L24.7652 30.0992L22.2942 32.4802L15.6797 23.0922L17.1852 21.6409L24.5086 24.4283L21.863 17.1315L23.3685 15.6802L32.4797 22.6624L30.1837 24.8754Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5913 11.8675L34.3888 13.2722L37.8738 11.2553L39.2034 13.5937L35.7179 15.613L36.5154 17.0163L41.1424 14.3385L42.5601 16.8338L34.8802 21.2802L29.1201 11.1395L36.7539 6.72021L38.172 9.21688L33.5913 11.8675Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2066 14.9494L45.1354 14.7099L46.0171 12.2558L46.2391 12.1792C46.9881 12.582 48.3614 12.8458 49.3295 12.5127C50.0917 12.2505 50.5073 11.8244 50.3805 11.3962C50.2027 10.7972 49.4891 10.9859 48.3658 11.033C46.6364 11.0996 44.4787 10.785 43.8284 8.59369C43.2243 6.55671 44.5062 4.56837 46.9508 3.72725C48.6968 3.12668 50.4979 3.30008 51.5549 3.97414L51.6261 4.21363L50.7086 6.60482L50.4861 6.68095C49.9095 6.38859 48.8334 6.00478 47.8014 6.35952C47.1983 6.56676 46.8727 6.94264 46.9896 7.33703C47.1516 7.88474 47.9424 7.89584 48.7072 7.87787C50.6473 7.8139 52.8565 7.77107 53.6031 10.2881C54.2887 12.5989 52.6438 14.4858 50.3422 15.2772C48.3899 15.9486 46.4733 15.7403 45.2066 14.9494Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6048 11.9719L60.3321 12.32L59.5336 3.55833L56.2609 3.90647L56 1.04627L65.8191 0L66.08 2.86067L62.8073 3.20973L63.6048 11.9719Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0401 0.252933L74.1441 11.2L70.5601 10.9471L71.4561 0L75.0401 0.252933Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.3446 15.4505L89.1183 15.6801L85.476 14.7258L83.6088 9.57612L82.787 10.1697L81.8854 13.785L78.3999 12.8722L81.3287 1.12012L84.8142 2.03292L83.7736 6.21052L88.0342 2.87758L91.7494 3.84965L91.8399 4.16185L86.6534 8.12012L89.3446 15.4505Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2991 15.3885L98.7051 12.3096L96.1811 14.3181L98.2991 15.3885ZM101.305 21.1219L101.031 21.2798L97.7654 19.6298L97.9919 17.8054L94.2254 15.9018L92.738 17.0889L89.6174 15.5114L89.6001 15.2064L99.8835 7.83984L101.92 8.86906L101.305 21.1219Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.977 31.3599L107.52 26.1734L116.127 17.9199L117.6 19.3209L110.238 26.3806L114.221 30.1662L112.977 31.3599Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.32 28.5496L115.374 35.8399L114.24 34.1702L123.185 26.8799L124.32 28.5496Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.174 41.9617L120.337 42.56L119.84 41.6593L127.944 32.48L128.133 32.4856L129.075 34.1959L122.996 40.7521L132.369 40.1678L133.28 41.8175L133.174 41.9617Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.445 50.3586L130.223 51.1361L131.442 55.4826L129.867 55.8634L128.646 51.5169L125.353 52.3121L126.906 57.8426L125.259 58.2402L123.2 50.9098L134.586 48.1602L136.64 55.4747L134.994 55.8723L133.445 50.3586Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.48 68.3198C131.409 68.3203 132.16 69.072 132.16 70.0005C132.16 70.929 131.408 71.6803 130.48 71.6798C129.551 71.6794 128.8 70.9281 128.8 69.9992C128.801 69.0707 129.552 68.3198 130.48 68.3198ZM125.918 97.1261C128.87 98.815 129.662 102.376 127.792 105.429C125.921 108.481 122.309 109.522 119.358 107.834C116.422 106.153 115.614 102.584 117.485 99.5311C119.355 96.4782 122.967 95.4373 125.918 97.1261ZM120.207 101.089C119.403 102.402 119.761 104.041 121.183 104.854C122.606 105.668 124.265 105.184 125.07 103.871C125.874 102.558 125.515 100.919 124.092 100.105C122.67 99.2913 121.011 99.7761 120.207 101.089Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.056 80.6401L136.64 83.9317L135.109 89.3235C134.033 93.1138 131.054 94.7866 127.597 93.8039C124.104 92.8113 122.449 89.8222 123.525 86.0319L125.056 80.6401ZM126.907 84.9734L126.417 86.6996C125.978 88.2475 126.711 89.668 128.6 90.2043C130.489 90.7412 131.858 89.9192 132.298 88.3713L132.788 86.6451L126.907 84.9734Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.458 113.998L110.416 117.241L108.455 112.077L109.887 110.7L114.986 112.893L111.883 108.78L114.358 106.4L120.96 115.794L119.453 117.244L112.134 114.45L114.769 121.75L113.261 123.2L104.16 116.209L106.458 113.998Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.047 127.015L102.25 125.61L98.7617 127.623L97.4345 125.281L100.923 123.267L100.127 121.863L95.4959 124.536L94.0801 122.038L101.768 117.6L107.52 127.75L99.8784 132.16L98.4625 129.662L103.047 127.015Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4397 125.054L91.5105 125.295L90.6266 127.747L90.4041 127.824C89.6549 127.42 88.2817 127.154 87.3129 127.486C86.5504 127.746 86.1342 128.172 86.2605 128.6C86.4374 129.2 87.1522 129.012 88.2763 128.967C90.0061 128.903 92.1644 129.221 92.8124 131.413C93.4152 133.452 92.1305 135.438 89.6843 136.275C87.9373 136.874 86.1352 136.698 85.0789 136.022L85.0077 135.782L85.9279 133.393L86.1504 133.316C86.7267 133.609 87.8032 133.995 88.8359 133.642C89.4397 133.435 89.7654 133.06 89.649 132.666C89.4868 132.117 88.6963 132.105 87.9314 132.121C85.9903 132.182 83.7804 132.222 83.0361 129.704C82.3523 127.392 83.9991 125.507 86.3023 124.719C88.2566 124.05 90.1732 124.262 91.4397 125.054Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9231 128.024L75.1967 127.68L75.9873 136.449L79.2614 136.105L79.5199 138.969L69.6985 140L69.4399 137.138L72.7136 136.794L71.9231 128.024Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6001 138.627L62.4961 127.68L66.0801 127.933L65.1841 138.88L61.6001 138.627Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.303 123.43L47.5303 123.2L51.1703 124.158L53.0309 129.307L53.8541 128.714L54.7575 125.1L58.2398 126.016L55.3007 137.76L51.8189 136.845L52.8638 132.671L48.6013 135.999L44.8903 135.023L44.7998 134.711L49.9863 130.759L47.303 123.43Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3486 123.495L37.9382 126.573L40.4631 124.568L38.3486 123.495ZM35.3536 117.758L35.6277 117.6L38.8877 119.255L38.6594 121.079L42.4203 122.987L43.9084 121.802L47.0241 123.383L47.0402 123.688L36.7544 131.04L34.7202 130.008L35.3536 117.758Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6759 107.52L29.12 112.714L20.5105 120.96L19.04 119.558L26.405 112.503L22.4304 108.713L23.6759 107.52Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3203 110.327L21.2691 103.04L22.4003 104.714L13.4515 112L12.3203 110.327Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46626 96.9069L16.3047 96.3198L16.7999 97.2214L8.68313 106.4L8.49506 106.393L7.55426 104.681L13.6424 98.1263L4.268 98.7022L3.35986 97.0502L3.46626 96.9069Z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18873 88.5217L6.41433 87.7456L5.20007 83.3944L6.77833 83.0145L7.99213 87.3657L11.2896 86.5738L9.74307 81.0368L11.3913 80.6401L13.44 87.9785L2.04307 90.7201L0 83.3977L1.64733 83.001L3.18873 88.5217Z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M3.35986 69.9972C3.35857 70.926 4.10947 71.6785 5.03813 71.6798C5.96679 71.6807 6.719 70.9299 6.71987 70.002C6.72117 69.0736 5.97026 68.3211 5.04203 68.3198C4.11381 68.3185 3.36117 69.0693 3.35986 69.9972Z",
    fill: "inherit"
  }));
};

exports.DomestikaLive = DomestikaLive;
DomestikaLive.defaultProps = {
  width: '137px',
  height: '140px',
  color: 'coco'
};